<div class="container my-5">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/tasks">Tarefas</a></li>
      <li *ngIf="formGroup.get('id').value != ''" class="breadcrumb-item active" aria-current="page">Alterar</li>
      <li *ngIf="formGroup.get('id').value == ''" class="breadcrumb-item active" aria-current="page">Adicionar Novo</li>
    </ol>
  </nav>

  <h1 class="mt-4 container">Cadastro de Tarefa</h1>

  <div *ngIf="isSaving" class="backdrop">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Salvando as Informações...</span>
    </div>
  </div>

  <div id="fullPageContent" class="container my-2">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <section class="mb-4">
        <div class="row">
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome da Tarefa</mat-label>
              <input matInput id="title" formControlName="title" />
              <mat-error *ngIf="formGroup.get('title')?.hasError('required') && formGroup.get('title')?.touched">
                O nome é obrigatório.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Usuários</mat-label>
              <mat-select formControlName="people" multiple [disabled]="formGroup.get('id')?.value != ''">
                <mat-optgroup *ngIf="managers.length" label="Gestores">
                  <mat-option *ngFor="let person of managers" [value]="person.id">
                    {{ person.name }}
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup *ngIf="supervisors.length" label="Supervisores">
                  <mat-option *ngFor="let person of supervisors" [value]="person.id">
                    {{ person.name }}
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup *ngIf="users.length" label="Usuários">
                  <mat-option *ngFor="let person of users" [value]="person.id">
                    {{ person.name }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
              <mat-error *ngIf="formGroup.get('people')?.hasError('required')">
                É obrigatório selecionar ao menos um usuário.
              </mat-error>
            </mat-form-field>

            <!-- Exibir as opções selecionadas -->
            <p class="mt-2" [hidden]="formGroup.get('people')?.value == 0">Selecionados: {{ getSelectedPeople() }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição:</mat-label>
              <textarea
                matInput
                id="description"
                formControlName="description"
                placeholder="Escreva aqui a descrição para essa tarefa."
              ></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Início</mat-label>
              <input matInput id="startDate" type="date" formControlName="startDate" />
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Fim</mat-label>
              <input matInput id="endDate" type="date" formControlName="endDate" />
            </mat-form-field>
          </div>
        </div>
      </section>

      <div class="d-grid gap-2" *ngIf="!isSaving">
        <button type="submit" class="btn btn-primary" [disabled]="formGroup.invalid">Salvar</button>
      </div>

      <div *ngIf="isSaving" class="spinner-container">
        <div class="spinner"></div>
      </div>
    </form>

    <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show mt-4 mb-4" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show mt-4 mb-4" role="alert">
      {{ errorMessage }}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  </div>
</div>
